import { useEffect, useState } from "react";
import { getViewData } from "../core/views";
import { LOADING_VIEW_NAME } from "../core/constants";

export function InitializingView(props: { viewInitialized: boolean, viewInactive: boolean, activateApp: () => void}) {  
  const [loadingMessage, setLoadingMessage] = useState("");  
  const [showSupport, setShowSupport] = useState(false);
  const [showActivateButton, setShowActivateButton] = useState(false);
  const [supportMsg, setSupportMsg] = useState("");


  function loadNextMessage() {   
    const loadingState = getViewData(LOADING_VIEW_NAME);    
    if (loadingState?.cfg?.messages && loadingState?.cfg?.messages?.length > 0) {
      const messages = loadingState.cfg?.messages;
      setLoadingMessage(getRandomLoadingMessage(messages));        
    }    
    
  }

  if (loadingMessage === "app-loading") {
    loadNextMessage();
  }

  useEffect(() => {
    const meinInterval = setInterval(() => {
      loadNextMessage();
    }, 800);

    const activateTimeout = setTimeout(() => {
      setShowActivateButton(true);
    }, 500);

    const timeOut = setTimeout(() => {
      const loadingState = getViewData(LOADING_VIEW_NAME);   
      setSupportMsg(loadingState?.cfg?.support);
      setShowSupport(true);
    }, 10000);

    return () => {
      clearInterval(meinInterval);
      clearTimeout(activateTimeout);
      clearTimeout(timeOut);
    };
  }, []);

  const inactiveTitle = props.viewInitialized ? "Der Editor ist noch nicht aktiv." : "Der Editor ist zurzeit inaktiv."
  const buttonTitle = props.viewInitialized ? "Editor aktivieren" : "Editor reaktivieren";
  
  return (<>
    
    { !showActivateButton &&
      <div className="loading-container">
        <div className="text-center" style={ {marginTop : 50} }>
          <div className="mb-5">
            <h2>...</h2>
          </div>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Initializing</span>
          </div>
          
          <div className="mt-5">        
            <h5>{ loadingMessage }</h5>        
            { showSupport &&         
              <i>{ supportMsg }</i> 
            }
          </div>              
        </div>
      </div>
    }
    { showActivateButton &&
      <div className="inactive-container">
        <div className="inactive-message">
          <p>{ inactiveTitle }</p>
          <button onClick={props.activateApp}>{ buttonTitle }</button>
        </div>
      </div>    
    }
  </>);
}

const getRandomLoadingMessage = (messages : string[]) => {
  return messages[Math.floor(Math.random() * messages.length)];
}